export const testTarget = [
    {
        status: true,
        message: "Source has been tested successfully please click save and continue to continuethe process"
    }
]

